import React from 'react'
// import { FormattedMessage } from 'react-intl'
// import messages from './messages'
import classes from './styles.module.scss'
import { createForm } from 'rc-form'
import { Flex, WhiteSpace, WingBlank, Toast } from 'antd-mobile'
import { Button, Tips, Head, InviteCode, Banners } from 'components'
import {
  isPayBy,
  deeplink,
  checkFormError,
  openNative,
  redirectToOtherProject
} from 'utils'
import Div100vh from 'react-div-100vh'
import queryString from 'query-string'
import _ from 'lodash'
import { Skeleton } from 'antd'

class Referral extends React.Component {
  constructor(props) {
    super(props)
    const params = queryString.parse(location.search)
    console.log(params)
    this.state = {
      ...params,
      isPayBy: isPayBy()
    }
    if (this.state.isPayBy) {
      props.init({ inviteCode: this.state.inviteCode })
      props.queryKycStatus()
      props.queryConfigItem({ itemKey: 'REFERRAL_REWARDS' })
    }
  }

  componentDidUpdate = (prevProps) => {
    // TODO 重复的tipsInfo
    const { tipsInfo } = this.props.festivalReferralState
    if (
      !_.isEqual(prevProps.festivalReferralState.tipsInfo, tipsInfo) &&
      _.size(tipsInfo) &&
      tipsInfo.type !== 'Display'
    ) {
      // 活动过期或其他异常
      console.log(tipsInfo)
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({
        tipsInfo
      })
      this.props.setTipsVisible(true)
    }
  }

  handleClose = () => {
    // 关闭弹窗 清空弹窗数据
    this.setState({
      tipsInfo: {}
    })
    this.props.removeTipsInfo()
    this.props.setTipsVisible(false)
  }

  verifyCode = () => {
    Toast.loading('', 0)
    const { inviteCode } = this.props.form.getFieldsValue()
    console.log(inviteCode)
    if (inviteCode) {
      this.props.verifyCode({ invitationCode: inviteCode }, (data) => {
        if (data.result) {
          this.openKYC()
        } else {
          Toast.info(data.message)
        }
      })
    }
  }

  openKYC = () => {
    Toast.hide()
    openNative('route://native/kyc/startVerifyCenter', true, () => {
      Toast.loading('', 0)
      this.props.queryResult((data) => {
        console.log(data)
        const { bizData = {} } = data
        if (bizData.referralStatus === 'Y') {
          const { inviteCode } = this.props.form.getFieldsValue()
          this.setState({
            isVerify: true,
            inviteCode
          })
        }
      })
    })
  }

  handleButtonProps = (bizData) => {
    const { kycStatus } = this.props.siteConfig
    const { form } = this.props
    const img = <img src={require('../images/arrow-right.png')} width='7' key='img' />
    // 端外引导打开PayBy
    if (!this.state.isPayBy) {
      return {
        children: ['Activate PayBy Account to Collect', img],
        onClick: () => {
          deeplink(window.location.href)
        }
      }
    }
    if (bizData.referralStatus === 'Y' || this.state.isVerify) {
      return {
        children: ['Check Your Voucher', img],
        onClick: () => {
          Toast.loading('', 3)
          redirectToOtherProject('/coupon/list', 'mtopay')
        }
      }
    }
    if (kycStatus === 'KYC_FINISH') {
      return {
        disabled:
          !form.getFieldValue('inviteCode') ||
          this.props.form.getFieldError('inviteCode'),
        children: ['Submit Code to Get Vouchers', img],
        onClick: this.handleSubmit
      }
    }
    return {
      disabled:
        !form.getFieldValue('inviteCode') || this.props.form.getFieldError('inviteCode'),
      children: ['Complete Your Profile to Get Voucher', img],
      onClick: this.verifyCode
    }
  }

  handleSubmit = () => {
    // 提交邀请码
    Toast.loading('', 0)
    this.props.form.validateFields((errors, values) => {
      if (checkFormError(errors)) {
        this.props.submit(values, () => {
          this.setState({
            inviteCode: values.inviteCode
          })
        })
      }
    })
  }

  render() {
    const { festivalReferralState, siteConfig, history } = this.props
    const { inviteCode, isPayBy, isVerify } = this.state
    const { bizData = {}, tipsInfo = {} } = festivalReferralState
    // const redirectView = _.head(tipsInfo.redirectView)
    return (
      <Div100vh>
        <Head
          helmetTitle='Activate PayBy to Get AED 5 Voucher'
          title='Sharing referral code.'
          description='Refer friends to PayBy and earn cash rewards.'
          image={`https://alioss.payby.com/cms/linkshare.png?${new Date().valueOf()}`}
        />
        <Skeleton active loading={isPayBy && !festivalReferralState.showPage}>
          {tipsInfo.type === 'Display' ? (
            bizData.referralStatus === 'Y' ? (
              <Flex.Item className={`${classes.festivalReferral} ${classes.receive}`}>
                <WhiteSpace size='lg' />
                <div className='text-left'>
                  <img
                    style={{ marginLeft: 16 }}
                    src={require('public/images/logo-payby-white.png')}
                    height='30'
                  />
                  <img
                    className='pull-right'
                    src={require('../images/Campaign_Rules.png')}
                    height='30'
                    onClick={() => {
                      history.push('/festival/rules')
                    }}
                  />
                </div>
                <WhiteSpace />
                <WhiteSpace />
                <WhiteSpace />
                <WingBlank>
                  <WingBlank size='md'>
                    <h5 className='white'>
                      <b>
                        Oops! You've referred by your friend before. Can't redeem referral
                        rewards again.
                      </b>
                    </h5>
                  </WingBlank>
                  <WhiteSpace size='xl' />
                  <WhiteSpace />
                  <img src={require('../images/rewards.png')} width='100%' />
                  <Banners
                    siteConfig={siteConfig}
                    keyword='2022Referral_Referee'
                  />
                </WingBlank>
              </Flex.Item>
            ) : (
              <Flex
                direction='column'
                justify='center'
                style={{ padding: '0 16px', height: '100%' }}
              >
                <img src={tipsInfo.tipImg} width='120' />
                <WhiteSpace size='lg' />
                {tipsInfo.title && (
                  <p className='text-center black'>
                    <b>{tipsInfo.title}</b>
                  </p>
                )}
                <p className='font-sm text-center black'>{tipsInfo.tipText}</p>
              </Flex>
            )
          ) : (
            <Flex.Item className={classes.festivalReferral}>
              <WhiteSpace size='lg' />
              <div className='text-left'>
                <img
                  style={{ marginLeft: 16 }}
                  src={require('public/images/logo-payby-white.png')}
                  height='30'
                />
                <img
                  className='pull-right'
                  src={require('../images/Campaign_Rules.png')}
                  height='30'
                  onClick={() => {
                    history.push('/festival/rules')
                  }}
                />
              </div>
              <WingBlank>
                <WhiteSpace size='lg' />
                {isVerify || _.get(bizData, 'referralStatus') === 'Y' ? (
                  <React.Fragment>
                    <h3 className='white font-lg'>Congratulations!</h3>
                    <h4 className='white'>You've got the voucher!</h4>
                  </React.Fragment>
                ) : (
                  <h3 className='white'>Activate PayBy to Get AED 5 Voucher</h3>
                )}
                <WhiteSpace size='xl' />
                <img src={require('../images/cashgift.png')} width='248' />
                <WhiteSpace size='xl' />
                <InviteCode
                  isNotEdit={
                    !isPayBy || isVerify || _.get(bizData, 'referralStatus') === 'Y'
                  }
                  inviteCode={inviteCode}
                  form={this.props.form}
                  keyword='2022Referral_Referee'
                />
                <WhiteSpace size='lg' />
                {this.handleButtonProps(bizData) && (
                  <Button
                    className='am-button-normal white'
                    name='custom'
                    {...this.handleButtonProps(bizData)}
                  />
                )}
                {isPayBy && (isVerify || _.get(bizData, 'referralStatus') === 'Y') && (
                  <Banners
                    siteConfig={siteConfig}
                    keyword='2022Referral_Referee'
                  />
                )}
              </WingBlank>
            </Flex.Item>
          )}
        </Skeleton>
        {siteConfig.tipsVisible && (
          <Tips
            tipsInfo={this.state.tipsInfo}
            onClose={this.handleClose}
            wrapClassName='normal-modal'
          />
        )}
      </Div100vh>
    )
  }
}

export default createForm()(Referral)
